module.exports = __webpack_public_path__ + "img/avatar_wfp.7321b5bf.png";